import React from 'react';
import { ISlimApp } from '@biolibtech/biolib-js';
import SearchModalComboboxOption from '../atoms/SearchModalComboboxOption';
import SearchModalResourceList from '../atoms/SearchModalResourceList';
import clsx from 'clsx';

export enum SearchTab {
    Applications = 'Applications',
    Results = 'Results',
    DataRecords = 'Data Records',
    Groups = 'Groups',
    Experiments = 'Experiments',
}

export type SearchSelection = { path: string };

interface IProps {
    isLoading: boolean;
    query: string;
    resources: ISlimApp[];
    resourceTypeLabel: string;
    totalCount?: number;
    prefetchedMatches?: ISlimApp[];
}

export default function SearchModalResourcesTab(props: IProps) {
    const { resources, isLoading, query, totalCount, prefetchedMatches = [] } = props;

    const showViewMore = isLoading || (totalCount !== undefined && totalCount > 5);
    const viewMorePath = query ? `/explore/?q=${encodeURIComponent(query)}` : '/explore/';

    return (
        <li className='p-2'>
            <div className='mb-2'>
                <SearchModalResourceList
                    resources={resources}
                    isLoading={isLoading}
                    prefetchedMatches={prefetchedMatches}
                />
            </div>
            {!isLoading && resources.length === 0 && prefetchedMatches.length === 0 && (
                <p className='px-3 py-8 text-center text-sm text-gray-500 dark:text-gray-400'>
                    No {props.resourceTypeLabel} found for "{query}"
                </p>
            )}
            {showViewMore && (
                <SearchModalComboboxOption path={viewMorePath} disableFocusStyling={isLoading}>
                    <p
                        className={clsx(
                            'px-3 py-2 text-center text-sm text-cyan-800',
                            isLoading ? '' : 'group-data-[focus]:text-white',
                        )}
                    >
                        View more {props.resourceTypeLabel}
                        {!isLoading && totalCount !== undefined ? ` (${totalCount} total)` : null}
                    </p>
                </SearchModalComboboxOption>
            )}
        </li>
    );
}
